import React from 'react'
import "./tyc-estilos.css";
import Footer from './footer';
import { Helmet } from 'react-helmet-async';
export default function TyC() {
  
  return (
    <>
      <Helmet>
        <title>Términos y condiciones</title>
      </Helmet>
      <div className='contenedor-pagina'>
        <div className='Terminos'>
            <h1>Términos y condiciones para la realización de reservas a través de la plataforma Chamuscón.</h1>
            <br/>
            <p>Última actualización 21 de marzo de 2025 en Guatemala.</p>
            <br/>
            <p>Al utilizar los servicios de recepción y manejo de reservas en línea ofrecidos para las personas 
              jurídicas o individuales como intermediario entre el cliente final y los establecimientos que prestan el
              servicio, el usuario (cliente) acepta los siguientes términos y condiciones:</p>
            <br/>
            <h3>Términos:</h3>
            <br/>
            <ol type='1'>
              <li>
                <p>
                  <strong>Plataforma:</strong>
                  &nbsp;se entiende por plataforma a la página 
                  “<a href='https://www.chamuscon.com'>https://www.chamuscon.com</a>” y todos sus derivados.
                </p>
              </li>
              <li>
                <p>
                  <strong>Proveedor:</strong> 
                  &nbsp;se entiende por proveedor a la empresa “CHAMUSCÓN GUATEMALA”.
                </p>
              </li>
              <li>
                <p>
                  <strong>Clientes:</strong>
                  &nbsp;se entiende así a todos los consumidores finales, ya sean personas individuales o jurídicas, que
                  realizan las reservaciones a través de la plataforma.
                </p>
              </li>
              <li>
                <p>
                  <strong>Chamuscón:</strong>
                  &nbsp;se entiende de esta manera a la marca, es decir, plataformas, símbolos, signos, logotipos,
                  publicaciones y otros activos intangibles que realiza la empresa “CHAMUSCÓN GUATEMALA” en relación con
                  la plataforma.
                </p>
              </li>
              <li>
                <p>
                  <strong>Establecimiento:</strong>
                  &nbsp;se entiende de esta manera a las empresas y lugares físicos que se encuentran registrados como
                  “establecimientos” en la plataforma y que prestan el servicio de alquiler por hora de campos de fútbol
                  de distintos materiales a personas individuales y jurídicas.
                </p>
              </li>
              <li>
                <p>
                  <strong>Pasarela de pago:</strong>
                  &nbsp;se entiende de esta manera al proveedor que gestiona el pago monetarias entre el Cliente y el Proveedor.
                </p>
              </li>
              <li>
                <p>
                  <strong>Depósito:</strong>
                  es una garantía económica pagada por adelantado como seguro para la prestación de servicio del 
                  establecimiento.
                </p>
              </li>
            </ol>
            <br/>
            <h3>Condiciones:</h3>
            <br/>
            <ol type='1'>
              <li>
                <p>
                  <strong>Alcance del Servicio</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      El servicio incluye la gestión de reservas en línea para canchas de fútbol, facilitando la
                      realización de estas mediante el manejo de horarios, disponibilidad de servicios y el pago de estos.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Reserva</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Es responsabilidad de cada cliente colocar la información de manera correcta dentro del formulario
                      de reserva correspondiente, así como seleccionar la fecha, hora y establecimiento correspondiente.
                      Se exime de responsabilidad al proveedor por cualquier error que no pueda ser solucionado que sea
                      derivado de información incorrecta presentada por el cliente.
                    </p>
                  </li>
                  <li>
                    <p>
                      El proveedor Chamuscón es únicamente un intermediario de la relación entre el cliente y el
                      establecimiento, por lo que, las modificaciones, cancelaciones y aprobaciones de las reservas son
                      responsabilidad exclusiva de cada establecimiento.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Costo del Servicio</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Por cada reserva que se realiza en a través de la Plataforma se cobrarán Q1.00 añadido al total del
                      depósito con concepto de cobro por gestión de reserva.
                    </p>
                  </li>
                  <li>
                    <p>
                      El costo del servicio ya incluye el IVA.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Métodos de Pago</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      La Plataforma únicamente recibe pagos realizados con tarjetas de Débito y Crédito de bancos
                      guatemaltecos, con pagos al contado a través de la pasarela de pago.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Responsabilidad del Establecimiento</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Es responsabilidad de cada establecimiento mantener actualizado su establecimiento para la correcta
                      prestación de servicios a los clientes, teniendo a su disposición, de manera correcta los horarios y
                      canchas disponibles.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad de cada establecimiento mantener actualizadas las reservas que reciben por otros
                      medios distintos a la Plataforma, ingresadas a la Plataforma para evitar la recepción de reservas
                      que superen a la disponibilidad de cada establecimiento.
                    </p>
                  </li>
                  <li>
                    <p>
                      Cualquier disputa con los Clientes finales derivada de errores en la información proporcionada por
                      el Establecimiento será responsabilidad exclusiva del Establecimiento involucrado.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad del Establecimiento proporcionar los comentarios adecuados derivados del rechazo
                      de una reserva a través de la plataforma.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad del Establecimiento contactar a los clientes por los medios disponibles derivado
                      de la necesidad de realizar cambios en las reservas.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad del Establecimiento la aceptación y asignación de las distintas reservas recibidas
                      por la plataforma en un tiempo prudente previo a la hora de la reserva solicitada por un Cliente. 
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Limitaciones de Responsabilidad</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      El Proveedor del servicio no se hace responsable por interrupciones en el funcionamiento de la
                      plataforma causadas por factores fuera de su control, como fallos técnicos o problemas con
                      proveedores externos.
                    </p>
                  </li>
                  <li>
                    <p>
                      No se garantiza la efectividad de la plataforma en términos de generación de reservas o clientes.
                    </p>
                  </li>
                  <li>
                    <p>
                      Se exime de responsabilidad al Proveedor de las obligaciones fiscales de los clientes.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Responsabilidades del Proveedor</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Es responsabilidad del Proveedor la notificación de las reservaciones recibidas a través de la
                      Plataforma hacia los Establecimientos para que estos dispongan de su manejo.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad del Proveedor el mantenimiento de la Plataforma asegurando un correcto
                      funcionamiento para la utilización de esta por parte de los Establecimientos y Clientes.
                    </p>
                  </li>
                  <li>
                    <p>
                      Es responsabilidad del Proveedor la facturación del servicio a los Clientes que realicen
                      reservaciones a través de la plataforma.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Fiscal</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      El cliente puede solicitar su factura por el cargo extra de Q1.00 por el servicio de gestión de
                      reservas.
                    </p>
                  </li>
                  <li>
                    <p>
                      La factura por el arrendamiento de la cancha de fútbol es responsabilidad del establecimiento que
                      presta este servicio.  
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Cancelaciones</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Cuando el Cliente realice una cancelación de su reserva y esta se encuentre fuera de las 24 horas
                      previas al inicio de la reserva, se realizará un reembolso por el monto total de la transacción.
                    </p>
                  </li>
                  <li>
                    <p>
                      No hay devolución del depósito o cobro por gestión de la reserva dentro de las 24 horas previas a la
                      reserva.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Rechazo</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      En caso de ser un rechazo justificado que no sea derivado del incumplimiento de las
                      responsabilidades del Establecimiento, se realizará el reembolso de la totalidad pagada por el
                      cliente.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Reembolsos</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Los reembolsos derivados de una cancelación de la reserva el mismo día de la reserva realizada,
                      será procesado en un máximo de 3 días hábiles.
                    </p>
                  </li>
                  <li>
                    <p>
                      Los reembolsos realizados fuera del mismo día de realización de la reserva, será devuelto en 7 días
                      hábiles.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Penalizaciones</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      El depósito no es reembolsable dentro de las 24 horas previas a la reserva.
                    </p>
                  </li>
                  <li>
                    <p>
                      En caso de detectar actividades maliciosas de ingreso de reservas, así como de cancelaciones, se
                      anula el derecho de reembolso al cliente.
                    </p>
                  </li>
                  <li>
                    <p>
                      Si se detecta a un cliente que realice más de 6 cancelaciones de reservas en un periodo de 180 días
                      desde la primera cancelación, se le anula el derecho de reembolso hasta nuevo aviso.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Privacidad</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      El proveedor no maneja ni almacena ningún tipo de información sensible que tenga que ver con el pago
                      de las reservas.
                    </p>
                  </li>
                  <li>
                    <p>
                      El proveedor almacena la información proporcionada por el cliente en los formularios como nombres,
                      correos electrónicos, números de teléfono y demás información que es solicitada en los formularios
                      para su utilización interna y sin ser distribuida más allá de los establecimientos.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Aceptación de los Términos</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Al utilizar este servicio, el cliente declara haber leído, entendido y aceptado los presentes
                      términos y condiciones en su totalidad.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Duración y Terminación</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      Este acuerdo estará vigente mientras el cliente utilice el servicio de reservas en línea.
                    </p>
                  </li>
                </ul>
              </li>
            </ol>
            <p>
              Estos términos y condiciones entran en vigor desde la fecha de aceptación por parte del cliente y regirán
              todas las transacciones realizadas a través del sistema de reservas.
            </p>
            <p>
              En caso de incumplir con los términos y condiciones de la prestación del servicio, el Proveedor se reserva
              el derecho de detener la prestación del servicio.
            </p>
            <p>
              Para cualquier consulta adicional, favor de comunicarse al canal designado.
            </p>
            
        </div>
      <Footer/>
    </div>
  </>
  )
}
